import 'animate.css';
import { iNotification, NOTIFICATION_TYPE, Store } from 'react-notifications-component';

export const showAlert = (type: NOTIFICATION_TYPE, text: String, options: Partial<iNotification> = {}, duration = 8000) => {
  Store.addNotification({
    insert: "bottom",
    container: "bottom-center",
    message: text,
    type: type,
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: duration,
    },
    ...options
  });
}